import { setAlert } from "../stateManagement/actions/alert";

const errorLogger = (dispatch, err, errAction) => {
    const error = err.response 
                    ? err.response.data && err.response.data.error 
                    : "Ooops! An error just occurred!";
    dispatch(setAlert(error, 'danger'));
    dispatch({type: errAction});
}

export {
    errorLogger
}